export function imageHandling(url: string, size: string, imageExtension: string) {
    let urlImage = '';
    const baseUrl = url.replace('.png', '');
    if (size === 'small') {
        urlImage = `${baseUrl}_c${imageExtension}`;
    } else if (size === 'big') {
        urlImage = `${baseUrl}_p${imageExtension}`;
    } else if (size === 'full') {
        urlImage = `${baseUrl}${imageExtension}`;
    }
    return urlImage;
}
